<!--
// -----------------------------------------------------------------------------
// <copyright file="loader.component.html" company="ecoInsight, Inc.">
// Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>
// ------------------------------------------------------------------------------
-->

<!-- <div *ngIf="loading" class="pageLoader">
<div class="transparentloading "></div>
<img class="loadingimage" src="assets/icon/loader.svg" /><br><br>
</div> -->

@if (loading()) {
  <div>
    <div class="pageLoader"></div>
    <div class="snippet" data-title=".dot-pulse">
      <div class="stage">
        <div class="dot-pulse"></div>
      </div>
    </div>
  </div>
}
